import type { HGGetClubTournStructuresReply } from '@ps/web-shared-api-types/v0/SwHomeGames';
import { Translation } from '@ps/web-shared-components';
import React from 'react';

import { FormatTranslations, SpeedTranslations } from '@swf/poker';

import {
  TXTCLI_N0_levels,
  TXTCLI_No,
  TXTCLI_Top_N0NN,
  TXTCLI_Winner_Takes_All,
  TXTCLI_Yes
} from './getStandaloneOptions.messages.json';

const getPayoutText = (payout: number) =>
  payout === 0 ? (
    <Translation {...TXTCLI_Winner_Takes_All} />
  ) : (
    <Translation {...TXTCLI_Top_N0NN} values={{ 0: payout }} />
  );

const getStandaloneOptions = (structures: HGGetClubTournStructuresReply | undefined) => {
  if (!structures) {
    return {
      startingChipsOptions: [],
      payoutsOptions: [],
      tournLevelLengthsOptions: [],
      tournFormatsOptions: [],
      tournReentryOptions: [],
      tournLateRegLevelsOptions: [],
      tournSyncBreaksOptions: []
    };
  }

  const startingChipsOptions =
    structures.tournStartingChips?.map((chips) => ({
      text: chips.toString(),
      value: chips
    })) || [];

  const payoutsOptions =
    structures.tournPayouts
      ?.sort((a: number, b: number) => (a === 0 ? 1 : a - b))
      .map((payout) => ({
        text: getPayoutText(payout),
        value: payout
      })) || [];

  const tournLevelLengthsOptions =
    structures.tournLevelLengths?.map((levelLength) => ({
      text: <Translation {...SpeedTranslations[levelLength]} />,
      value: levelLength
    })) || [];

  const tournFormatsOptions =
    structures.tournFormats?.map((format) => ({
      text: <Translation {...FormatTranslations[format]} />,
      value: format
    })) || [];

  const tournReentryOptions =
    structures.tournReentry?.map((reentry) => ({
      text: reentry ? <Translation {...TXTCLI_Yes} /> : <Translation {...TXTCLI_No} />,
      value: Number(reentry)
    })) || [];

  const tournLateRegLevelsOptions =
    structures.tournLateRegLevels?.map((level) => ({
      text: <Translation {...TXTCLI_N0_levels} values={{ 0: level }} />,
      value: level
    })) || [];

  const tournSyncBreaksOptions =
    structures.tournSyncBreaks?.map((breakValue) => ({
      text: breakValue ? <Translation {...TXTCLI_Yes} /> : <Translation {...TXTCLI_No} />,
      value: Number(breakValue)
    })) || [];

  return {
    startingChipsOptions,
    payoutsOptions,
    tournLevelLengthsOptions,
    tournFormatsOptions,
    tournReentryOptions,
    tournLateRegLevelsOptions,
    tournSyncBreaksOptions
  };
};

export default getStandaloneOptions;
